module.exports = __webpack_public_path__ + "static/media/gw-logo-white-horizontal.2d1e324c.svg";